// scheduledJobs page strings. Keys are read as $t('scheduledJobs.<key>').
export default {
  en: {
    pageTitle: 'Scheduled jobs - FitFoodCS',
    title: 'Scheduled jobs',
    subtitle: 'The jobs the server runs on a timer. They are set in the repo (fitfoodCS/cron) and each deploy installs them.',
    thisServer: 'This server: {site} · server time {time} ({zone})',
    sites: { production: 'Production', alpha: 'Alpha', ann: 'Ann', local: 'a local computer' },
    runsOn: 'Runs on {site}',
    noCrontab: "This server's crontab cannot be read here.",
    schedule: 'When',
    nextRun: 'Next run',
    installed: 'On this server',
    yes: 'Installed',
    no: 'Not installed',
    unknown: 'Cannot check',
    command: 'Command',
    log: 'Last runs',
    noLog: 'No log yet: it has not run on this server.',
    empty: 'No scheduled jobs.',
  },
  vi: {
    pageTitle: 'Tác vụ định kỳ - FitFoodCS',
    title: 'Tác vụ định kỳ',
    subtitle: 'Các tác vụ máy chủ tự chạy theo giờ. Được đặt trong mã nguồn (fitfoodCS/cron) và mỗi lần deploy sẽ cài lại.',
    thisServer: 'Máy chủ này: {site} · giờ máy chủ {time} ({zone})',
    sites: { production: 'Production', alpha: 'Alpha', ann: 'Ann', local: 'máy cá nhân' },
    runsOn: 'Chạy trên {site}',
    noCrontab: 'Không đọc được crontab của máy chủ này.',
    schedule: 'Lịch chạy',
    nextRun: 'Lần chạy tới',
    installed: 'Trên máy chủ này',
    yes: 'Đã cài',
    no: 'Chưa cài',
    unknown: 'Không kiểm tra được',
    command: 'Lệnh',
    log: 'Các lần chạy gần nhất',
    noLog: 'Chưa có log: tác vụ chưa chạy trên máy chủ này.',
    empty: 'Không có tác vụ định kỳ.',
  },
}
